import React, { useState, useEffect, useCallback } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Section, Cell, Spinner } from '@telegram-apps/telegram-ui';
import { BackButton } from '../components/BackButton';

interface CatalogItem {
    id: number;
    title: string;
    image: string | null;
    price: number;
    description_short: string | null;
}

interface CatalogResponse {
    items: CatalogItem[];
    count: number;
}

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://rentstation.ru';

function CatalogPage() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [items, setItems] = useState<CatalogItem[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const category = searchParams.get('category');
    const start = searchParams.get('start');
    const end = searchParams.get('end');

    const handleBack = useCallback(() => {
        navigate('/');
    }, [navigate]);

    useEffect(() => {
        const params = new URLSearchParams();
        if (category) params.append('category', category);
        if (start) params.append('start', start);
        if (end) params.append('end', end);

        const url = `${API_BASE_URL}/api/catalog${params.toString() ? '?' + params.toString() : ''}`;

        fetch(url)
            .then((res) => {
                if (!res.ok) throw new Error('Failed to fetch catalog');
                return res.json();
            })
            .then((data: CatalogResponse) => {
                setItems(data.items);
                setLoading(false);
            })
            .catch((err) => {
                setError(err.message);
                setLoading(false);
            });
    }, [category, start, end]);

    if (loading) {
        return (
            <Section header="Каталог">
                <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
                    <Spinner size="m" />
                </div>
            </Section>
        );
    }

    if (error) {
        return (
            <Section header="Каталог">
                <Cell subtitle={API_BASE_URL}>Ошибка загрузки: {error}</Cell>
            </Section>
        );
    }

    return (
        <>
            <BackButton />
            <Section header="Каталог">
                {items.map((item) => (
                    <Cell
                        key={item.id}
                        subtitle={`${item.price} ₽/день`}
                        before={item.image ? <img src={item.image} alt={item.title} style={{ width: 48, height: 48, objectFit: 'cover', borderRadius: 8 }} /> : undefined}
                        onClick={() => navigate(`/item/${item.id}`)}
                    >
                        {item.title}
                    </Cell>
                ))}
            </Section>
        </>
    );
}

export default CatalogPage;
